import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroup from 'shared/ui/FormGroup/FormGroup';
import HintQuestion from 'shared/ui/Hint/HintQuestion';
import RadioGroup from 'shared/ui/RadioGroup/RadioGroup';
import InputText from 'shared/ui/Input/InputText';
import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import SettingsArrow from '../../SettingsArrow/SettingsArrow';
import FieldCard from '../FieldCard/FieldCard';
import {getBodyMethodHint, getParseErrorsHelpText} from '../checkboxBlockHints';

import styles from '../CheckboxBlock.module.scss';

interface IParseErrorsFieldProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
    selective: boolean,
    freeTariff: boolean,
    isChecked: boolean,
    isJson: boolean,
    bodyMethodDisabled: boolean,
    onCheckboxClick: () => void,
    onRemove?: () => void,
}

const ParseErrorsField: React.FC<IParseErrorsFieldProps> = ({
    item,
    control,
    register,
    selective,
    freeTariff,
    isChecked,
    isJson,
    bodyMethodDisabled,
    onCheckboxClick,
    onRemove,
}) => {
    // eslint-disable-next-line max-len
    const jsonArrayHint = t`Если страница возвращает сразу JSON-массив, поле оставьте пустым. Если массив находится внутри объекта — укажите путь к нему через точку. Пример: result.errors.`;
    // eslint-disable-next-line max-len
    const regexpHint = t`Шаблон регулярного выражения, по которому ищутся ошибки. Сообщение об ошибке выделяется именованной группой. Пример: /- ?message.+)(\\r\\n|\\r|\\n)?/..`;

    return (
        <FieldCard selective={selective} freeTariff={freeTariff} auth onRemove={onRemove}>
            <div onClick={onCheckboxClick}>
                <PremiumCheckbox
                    label={t`Проверка подсистем`}
                    helpText={getParseErrorsHelpText()}
                    register={register('parse_errors')}
                    enabled={true}
                    disabled={bodyMethodDisabled}
                />
            </div>

            {bodyMethodDisabled && (
                <p className={styles.methodHint}>{getBodyMethodHint()}</p>
            )}

            {!selective && (
                <SettingsArrow checkboxName="parse_errors" isOpen={isChecked}/>
            )}
            {isChecked && (
                <>
                    <FormGroup className={styles.formGroupRadio}>
                        <RadioGroup
                            name="parse_errors_type"
                            options={[
                                {
                                    value: 'json',
                                    label: 'JSON',
                                    hint: t`JSON — страница возвращает список проблем в формате JSON-массива.`,
                                },
                                {
                                    value: 'regexp',
                                    label: 'Regex',
                                    // eslint-disable-next-line max-len
                                    hint: t`Регулярное выражение — страница возвращает список проблем в виде текста или HTML, поиск идёт по шаблону.`,
                                },
                            ]}
                            required
                            control={control}
                        />
                    </FormGroup>

                    <FormGroup>
                        {isJson ? (
                            <label key="json_label" className={styles.labelArray}>
                                {t`Путь к массиву`}
                                <HintQuestion placement="top-start">
                                    {jsonArrayHint}
                                </HintQuestion>
                            </label>
                        ) : (
                            <label key="regexp_label" className={styles.labelArray}>
                                {t`Шаблон регулярного выражения`}
                                <HintQuestion placement="top-start">
                                    {regexpHint}
                                </HintQuestion>
                            </label>
                        )}
                        <InputText
                            defaultValue={item?.parse_errors_pattern}
                            name="parse_errors_pattern"
                            register={register}
                            control={control}
                        />
                    </FormGroup>
                </>
            )}
        </FieldCard>
    );
};

export default ParseErrorsField;
